import { Component } from 'react'
import { Code, Period, CodeableConcept } from '../helpers'
import { GrCertificate } from 'react-icons/gr'

import './resource.css'

class Coverage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><GrCertificate /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.type && 'Type'}</div>
                            <div style={{ textAlign: 'right' }} className='Res-Title'>{this.props.resource.type && CodeableConcept(this.props.resource.type)}</div>
                        </div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.subscriberId && 'Subscriber ID'}</div>
                        <div className='Res-Title'>{this.props.resource.subscriberId && this.props.resource.subscriberId}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.dependent && 'Dependent'}</div>
                        <div className='Res-Title'>{this.props.resource.dependent && this.props.resource.dependent}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.network && 'Network'}</div>
                        <div className='Res-Title'>{this.props.resource.network && this.props.resource.network}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.relationship && 'Relationship'}</div>
                        <div className='Res-Title'>{this.props.resource.relationship && CodeableConcept(this.props.resource.relationship)}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.period && 'Period'}</div>
                        <div className='Res-Title'>{this.props.resource.period && Period(this.props.resource.period)}</div>
                    </div>
                </div>
            }
        </div></div>
    }
}

export default Coverage